import React, {useEffect, useState} from 'react';
import videoFrameStyle from './style';

export default function VideoFrame({id, thumbnail, i}) {
	/* let title = cleanTitle(inTitle); */
	let style = videoFrameStyle();
	let [videoLoading, setVideoLoading] = useState(true);
	let [startVideoLoading, startVideo] = useState(false);

	let localCode = getCleanCode();

	useEffect(() => {
		let imageEle = document.querySelector(`#video-thumbnail-${localCode}-${i}`);
		imageEle.addEventListener('click', showIframeLoader);
		return () => {
			imageEle.removeEventListener('click', showIframeLoader);
		};
	}, []);
	useEffect(() => {
		if (startVideoLoading) {
			let iframeEle = document.getElementById(`videoFrame${localCode}-${i}`);
			iframeEle.onLoad = () => {
				showIframe();
			};
		}
	}, [startVideoLoading]);

	function showIframe() {
		setVideoLoading(false);
	}
	function showIframeLoader() {
		startVideo(true);
	}

	if (startVideoLoading) {
		return (
			<>
				<iframe
					id={`videoFrame${localCode}-${i}`}
					key={i}
					style={style.iframeStyle(videoLoading)}
					src={`https://www.youtube.com/embed/${id}`}
					title='YouTube video player'
					frameBorder='0'
					allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
					allowFullScreen
					onLoad={showIframe}
				></iframe>

				<p className={`px-3 mt-3 ${videoLoading ? '' : 'd-none'}`}>Loading</p>
			</>
		);
	} else {
		return (
			<img
				style={style.imageThumbnailStyle()}
				className={style.imageThumbnailClasses()}
				id={`video-thumbnail-${localCode}-${i}`}
				src={thumbnail || null}
			></img>
		);
	}
}

function getCleanCode() {
	let cleanCode = Math.random() * 100 + 1;
	cleanCode = Math.round(cleanCode);

	return cleanCode;
}
